import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';
import { Business, BusinessSchema } from '@40seas/entities/businesses';

export const UserPermissionsSchema = z
    .object({
        buyers: z
            .array(
                z
                    .string()
                    .regex(/^[0-9a-f]{24}$/i)
                    .or(BusinessSchema),
            )
            .optional(),
    })
    .strict();

export class UserPermissions extends FromSchema(UserPermissionsSchema) {
    buyers?: string[];
}
